<template>
  <div class="wia-autocomplete">
    <h2 class="wia-title wia-title__black">{{config.i18n.wia_issue_search}}</h2>
      <div class="wia-autocomplete-description">{{config.i18n.wia_issue_description}}</div>
      <div class="input-autocomplete">
      <div class="input-autocomplete__line">
        <div class="input-autocomplete__input">
          <input
            type="text"
            @input="onChange"
            v-model="search"
            ref="autocompleteInput"
            :placeholder="config.i18n.wia_issue_placeholder"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter="searchSelectedIfPresent"
            class="input-autocomplete__input-field"
          />
          <div
            v-show="isOpen"
            class="input-autocomplete__results"
            :class="{ 'input-autocomplete__results--loading': isLoading }"
          >
            <div class="wia-loader wia-loader--light" v-show="isLoading">
              <div class="wia-loader__loader"></div>
            </div>
            <div v-if="!groups.length && !isLoading" class="input-autocomplete__cluster">
              <div class="input-autocomplete__cluster-macrocategory">{{config.i18n.wia_issue_no_results}}</div>
            </div>
            <div
              v-for="(group, i) in groups"
              v-else
              :key="i"
              class="input-autocomplete__cluster"
            >
              <div class="input-autocomplete__cluster-macrocategory">{{ group.key }}</div>
              <div
                v-for="(item, ind) in group.items"
                :key="ind"
                @click="setResult(item)"
                class="input-autocomplete__cluster-suggestion"
                :class="{ 'input-autocomplete__cluster-suggestion--active': (ind + getPastItemsCount(i, groups)) === arrowCounter }"
              >
                {{ item.problemId_descr}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'

export default {
  name: 'WIAInputAutocomplete',
  props: {
    groups: {
      type: Array,
      required: false,
      default: () => []
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      search: '',
      results: [],
      arrowCounter: 0,
      debouncedSearch: debounce(this.doSearch, 500)
    }
  },
  computed: {
    config: function () {
      return this.$store.state.config
    }
  },
  methods: {
    getPastItemsCount (currentIndex, groups) {
      return !currentIndex ? 0 : groups
        .slice(0, currentIndex)
        .reduce((acc, val) => acc + val.items.length, 0)
    },
    doSearch () {
      if (!this.search.length) {
        this.$emit('reset')
        this.isOpen = false
      } else if (this.search.length > 1) {
        this.$emit('input', this.search)
        this.isOpen = true
        this.isLoading = true
      }
    },
    onChange () {
      this.debouncedSearch()
    },
    onArrowDown (event) {
      event.preventDefault()
      if (this.arrowCounter < this.groups.flatMap(({ items }) => items).length - 1) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp (event) {
      event.preventDefault()
      if (this.arrowCounter >= 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    searchSelectedIfPresent () {
      const selectedItem = this.groups.flatMap(({ items }) => items)[this.arrowCounter]
      this.search = selectedItem.problemId_descr
      selectedItem && this.$emit('select', selectedItem)
      this.arrowCounter = -1
      this.isOpen = false
    },
    setResult (result) {
      this.search = result.problemId_descr
      this.$emit('select', result)
    },
    handleClick (event) {
      if (!this.$refs.autocompleteInput.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      } else {
        this.isOpen = !!this.groups.length
      }
    }
  },
  watch: {
    groups: function (val, oldValue) {
      this.isLoading = false
      this.arrowCounter = -1
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClick)

    // Check for search string
    if (this.$store.state.details.searchString !== null) {
      this.search = this.$store.state.details.searchString
    }
  },
  destroyed () {
    document.removeEventListener('click', this.handleClick)
  }
}
</script>
<style lang="scss">
  @import "../../style/main";

  .wia-autocomplete{
    display: flex;
    flex-direction: column;
    padding: 5rem 0;
    gap: 1rem;

    @media (min-width: $desktop) {
      .wia-title{
        font-size: 32px;
      }
    }&-description{
    display: flex;
    justify-content: center;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: normal;

  }
  }

  .input-autocomplete__results > .wia-loader {
    display: block;
    position: absolute;

    .wia-loader__loader{
      top: 50%;
      width: 2rem;
      height: 2rem;
    }
  }

  .input-autocomplete {
    position: relative;

    &__line {
      display: flex;
      align-items: stretch;
      justify-content: center;
      position: relative;
    }
    &__cluster {
      list-style: none;
      display: flex;
      flex-direction: column;

      &-macrocategory {
        padding: 5px 0;
        color: #999999;
      }

      &-suggestion {
        list-style: none;
        text-align: left;
        padding: 5px 10px;
        cursor: pointer;
        color: #2e2e2e;
        font-size: 14px;

        &:before{
          display: none !important;
        }

        &--active, &:hover {
          background-color: map-get($colors, main-font-icon-id);
          color: white;
        }
      }
    }

    &__input {
      width: 85% !important;
      position: relative;
      z-index: 1;

      @media (min-width: $desktop) {
        width: 60% !important;
      }

      &-field {
        padding: 1rem !important;
        border: 4px solid #eeeeee !important;
        border-radius: 10px !important;
        width: 100%;
      }
      &-field{
        box-shadow: 0 0 0 0.2rem map-get($colors, main-button-backgroud-id);
        outline: none;
      }
    }

    &__results {
      position: absolute;

      padding: 1rem;
      margin: 0;
      border: 2px solid #eeeeee;
      min-height: 2rem;
      max-height: 240px;
      width: 100%;
      overflow: auto;
      background-color: white;
      border-radius: 10px;
      z-index: 3;

      &--loading {
        background-color: map-get($colors, light-gray);
      }
    }
  }

  .brand-theme-id{
    .input-autocomplete__input-field{
      box-shadow: 0 0 0 0.2rem map-get($colors, main-button-backgroud-id);
    }
    @include placeholder {
      font-size: 1.3rem;
    }
    .input-autocomplete {
      &__results {
        min-height: 5rem;
      }

      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-id);
          background-color: map-get($colors, main-font-icon-id);
        }
      }
    }
  }

  .brand-theme-mb{
    .input-autocomplete__input-field{
      box-shadow: 0 0 0 0.2rem map-get($colors, main-button-background-mb);
    }
    @include placeholder {
      font-size: 1.3rem;
    }
    .input-autocomplete {
      &__results {
        min-height: 5rem;
      }

      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-mb);
          background-color: map-get($colors, main-font-icon-mb);
        }
      }
    }
  }

  .brand-theme-wp{
    .input-autocomplete {
      &__input {
        @media (min-width: $desktop) {
          width: 40% !important;
        }

        &-field {
          border: none !important;
          border-bottom: 2px solid #eeeeee !important;
          border-radius: 0 !important;
          font-size: 1.2rem;
        }
        &-field{
          box-shadow: 0 0 0 0.2rem  map-get($colors,  main-button-backgroud-wp);
        }
      }

      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-wp);
          background-color: map-get($colors, main-font-icon-wp);
        }
      }
    }
  }

  .brand-theme-wp-2020 {
    .input-autocomplete {
      &__input {
        @media (min-width: $desktop) {
          width: 40% !important;
        }

        &-field {
          border: none !important;
          border-bottom: 2px solid #eeeeee !important;
          border-radius: 0 !important;
          font-size: 1.2rem;
        }
        &-field{
          box-shadow: 0 0 0 0.2rem map-get($colors, main-button-backgroud-wp);
        }
      }

      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-wp);
          background-color: map-get($colors, main-font-icon-wp);
        }
      }
    }
  }

  .brand-theme-hp{
    @include placeholder {
      font-size: 1.3rem;
    }
    .input-autocomplete__input-field{
      box-shadow: 0 0 0 0.2rem map-get($colors, main-button-backgroud-hp);
    }
    .input-autocomplete {
      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-hp);
          background-color: map-get($colors, main-font-icon-hp);
        }
      }

      &__cluster-macrocategory {
        text-align: start;
      }
    }
  }

  .brand-theme-bk{
    .input-autocomplete__input-field{
      box-shadow: 0 0 0 0.2rem map-get($colors, main-button-backgroud-bk);
    }

    .input-autocomplete {
      &__cluster-suggestion {
        &--active, &:hover {
          color: map-get($colors, main-color-bk);
          background-color: map-get($colors, main-font-icon-bk);
        }
      }
    }
  }
</style>
